import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import api from './api'
import storage from './utils/storage'
import request from './utils/request'
import ElementPlus from 'element-plus'
import cookie from 'vue-cookie'
import axios from 'axios'
import 'element-plus/dist/index.css'
import './assets/scss/index.scss'
import Vant from 'vant'
import store from './store'
import * as ELIcons from '@element-plus/icons-vue'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import locale from 'element-plus/es/locale/lang/zh-cn'
import VueKonva from 'konva'
const instance = axios.create({
  baseURL: '',
  withCredentials: false
})
const app = createApp(App)
app.config.globalProperties.$request = request;
app.config.globalProperties.$ajax = instance
app.config.globalProperties.$api = api;
app.config.globalProperties.$storage = storage;
for (let iconName in ELIcons) {
  app.component(iconName, ELIcons[iconName])
}
app.use(router).use(ElementPlus, { locale }).use(Vant).use(store).use(VueViewer).use(VueKonva).mount('#app')
app.config.globalProperties.$cookie = cookie;
/* viewer全局去掉底部导航 */
VueViewer.setDefaults({ toolbar: true, navbar: false })
// console.log(process.env)

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})